<div class="main-container">
  <app-login-form
    [isModal]="true"
    [title]="'page.login.sessionExpired'"
    (loginFormSubmit)="loginFormSubmit($event)"
    (logoutClick)="logoutClick()"
    (forgotPasswordClick)="onForgotPassword()"
  ></app-login-form>
</div>
